import { Get, Put } from '../helpers';
import { UpsertBccEmailsRow, ChannelBccEmail } from '@/types/email.types';

export const GetBccEmails = ({ channel }: { channel: number }): Promise<{ emails: ChannelBccEmail[] }> => {
  return Get({
    path: `/v3/admin/channel/bcc-emails/${channel}`,
  });
};

export const SetBccEmails = ({
  channel,
  emails,
}: {
  channel: number;
  emails: UpsertBccEmailsRow[];
}): Promise<ChannelBccEmail[]> => {
  return Put({
    path: `/v3/admin/channel/bcc-emails/${channel}`,
    body: { emails },
  });
};
